module.exports = __webpack_public_path__ + "static/flexit-7a95aec2fc5fb56a32ff1030a3d10adb.png";